import { render, staticRenderFns } from "./UpcomingReminders.vue?vue&type=template&id=b26bd0f2"
import script from "./UpcomingReminders.vue?vue&type=script&lang=js"
export * from "./UpcomingReminders.vue?vue&type=script&lang=js"
import style0 from "./UpcomingReminders.vue?vue&type=style&index=0&id=b26bd0f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports